import { isNil } from 'lodash';
import { NeighborhoodCardLabels } from 'store/sagas/apiService/types';
import { NeighborhoodInsightChipType } from '../InsightChip/types';
import { ITranslate } from 'locale';

export const getLabel = (labels: NeighborhoodCardLabels, t: ITranslate) => {
  switch (true) {
    case !isNil(labels.dealsVolume):
      return {
        type: NeighborhoodInsightChipType.DEALS_VOLUME,
        text: t('investors.insights.neighborhoodCardLabels.dealsVolume', { value: labels.dealsVolume }),
      };
    case !isNil(labels.pricePerMeter):
      return {
        type: NeighborhoodInsightChipType.PRICE_PER_METER,
        text: t('investors.insights.neighborhoodCardLabels.pricePerMeter', { value: labels.pricePerMeter }),
      };
    case !isNil(labels.priceTrendComparedToCity):
      return {
        type: NeighborhoodInsightChipType.PRICE_TREND_COMPARED_TO_CITY,
        text: t('investors.insights.neighborhoodCardLabels.priceTrendComparedToCity', { value: labels.priceTrendComparedToCity }),
      };
    case !isNil(labels.popularRoom):
      return {
        type: NeighborhoodInsightChipType.POPULAR_ROOM,
        text: t('investors.insights.neighborhoodCardLabels.popularRoom', { value: labels.popularRoom }),
      };
    default:
      return null;
  }
};
